"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Right = _interopRequireDefault(require("@ucloud/ucloud-icons/dist/uc-directional/svgr/Right"));

var _Typography = _interopRequireDefault(require("../Typography"));

var _style = require("./style");

var _excluded = ["children"];
var Text = _Typography["default"].Text;
LoginName.propTypes = {
  /** @ignore */
  children: _propTypes["default"].node
};

function LoginName(_ref) {
  var children = _ref.children,
      others = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_style.StyledWrapper, others, /*#__PURE__*/_react["default"].createElement("span", {
    className: _style.iconCls
  }, /*#__PURE__*/_react["default"].createElement(_Right["default"], null)), /*#__PURE__*/_react["default"].createElement(Text, {
    className: _style.textCls,
    size: "t3",
    isCode: true
  }, children));
}

var _default = LoginName;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ui-components/lib/components/LoginName/LoginName.js
// module id = 2102
// module chunks = 6 7 17 18